
import Vue from 'vue';
import { currentCountry, app } from '@/utils/starters';
import {
  PA, GT, SV, HN, CR, NI, MPC, MCA, MCW, CHATBOT, COUNTRY
} from '@/utils/constants';

export const state = Vue.observable({
  country: COUNTRY[currentCountry],
  app,
  isLoading: false,
  currentStep: 0,
  layout: false
});

export const setApp = (newApp) => {
  state.app = newApp;
};

export const setLoading = (isLoading) => {
  state.isLoading = isLoading;
};

export const setCountry = (country) => {
  state.country = country;
};

export const setCurrentStep = (currentStep) => {
  state.currentStep = currentStep;
};

export const setLayout = (layout) => {
  state.layout = layout;
};

export const isPA = () => state.country.pais === PA;
export const isSV = () => state.country.pais === SV;
export const isGT = () => state.country.pais === GT;
export const isHN = () => state.country.pais === HN;
export const isCR = () => state.country.pais === CR;
export const isNI = () => state.country.pais === NI;

export const isMPC = () => state.app === MPC;
export const isMCA = () => state.app === MCA;
export const isMCW = () => state.app === MCW;
export const isChatbot = () => state.app === CHATBOT;

export default {
  state,
  setApp,
  setLoading,
  setCountry,
  isPA,
  isSV,
  isGT,
  isHN,
  isCR,
  isNI,
  isMPC,
  isMCA,
  isMCW,
  isChatbot,
  setCurrentStep,
  setLayout
};
